import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert } from 'antd';
import { txt } from 'libs/i18n';
const AlertWithContactLink = ({ message, linkText, type, }) => (_jsx(Alert, { showIcon: true, message: (_jsxs("span", { children: [message, ' ', _jsx("a", { href: txt('contactLink'), target: "_blank", rel: "noreferrer", children: linkText })] })), type: type }));
export default AlertWithContactLink;
